module.exports = __webpack_public_path__ + "img/stress_less_thrive_more.0363d4fc.png";